import React, { type PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import type { RootState } from './store';

export default function MainWrapper({ children }: PropsWithChildren) {
  const location = useLocation();
  const theme = useSelector((state: RootState) => state.theme);
  const rtl = useSelector((state: RootState) => state.rtl);
  const direction = location.pathname === '/' ? 'ltr' : rtl.direction;

  return (
    <div className={`${theme.className} ${direction}-support`} dir={direction}>
      <div className="wrapper">{children}</div>
    </div>
  );
}
